import React from 'react';
import { useTranslation } from 'react-i18next';
import './ContactPage.css';

const ContactPage: React.FC = () => {
  const { t } = useTranslation('legal');

  return (
    <div className="contact-page">
      <div className="contact-header">
        <h1>{t('contact.title')}</h1>
        <p>{t('contact.subtitle')}</p>

        <div className="wave-divider">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
          </svg>
        </div>
      </div>

      <section>
        <div className="contact-content bg-white p-5 rounded shadow">
          <h2 className="support-title">{t('contact.support_title')}</h2>

          <div className="contact-cards">
            <div className="contact-card">
              <div className="contact-icon">
                <i className="fas fa-clock"></i>
              </div>
              <h3>{t('contact.hours_title')}</h3>
              <p>{t('contact.hours_weekday')}</p>
              <p>{t('contact.hours_weekend')}</p>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <h3>{t('contact.email_title')}</h3>
              <p>{t('contact.email_desc')}</p>
              <a href="mailto:support@ai-reports.ru" className="contact-email">support@ai-reports.ru</a>
              <p className="response-time">{t('contact.response_time')}</p>
            </div>
          </div>

          <div className="company-info">
            <h2>{t('contact.company_title')}</h2>

            <div className="info-grid">
              <div className="info-item">
                <div className="info-label">
                  <i className="fas fa-user"></i>
                  <span>{t('contact.label_sp')}</span>
                </div>
                <div className="info-value">Вагапова Лилия Абдулхаковна</div>
              </div>

              <div className="info-item">
                <div className="info-label">
                  <i className="fas fa-id-card"></i>
                  <span>{t('contact.label_tin')}</span>
                </div>
                <div className="info-value">165807356527</div>
              </div>

              <div className="info-item">
                <div className="info-label">
                  <i className="fas fa-money-check"></i>
                  <span>{t('contact.label_account')}</span>
                </div>
                <div className="info-value">40802810300000973335</div>
              </div>

              <div className="info-item">
                <div className="info-label">
                  <i className="fas fa-university"></i>
                  <span>{t('contact.label_bank')}</span>
                </div>
                <div className="info-value">АО "ТИНЬКОФФ БАНК"</div>
              </div>

              <div className="info-item">
                <div className="info-label">
                  <i className="fas fa-sort-numeric-up"></i>
                  <span>{t('contact.label_bic')}</span>
                </div>
                <div className="info-value">044525974</div>
              </div>

              <div className="info-item">
                <div className="info-label">
                  <i className="fas fa-credit-card"></i>
                  <span>{t('contact.label_corr_account')}</span>
                </div>
                <div className="info-value">30101810145250000974</div>
              </div>
            </div>

            <div className="tax-info">
              <div className="info-icon">
                <i className="fas fa-info-circle"></i>
              </div>
              <p>{t('contact.tax_info')}</p>
            </div>
          </div>

          <div className="contact-message">
            <div className="message-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <p>{t('contact.confidentiality')}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
